import axios from 'axios';
import Cookies from 'js-cookie';
import * as Sentry from '@sentry/browser';
import auth from './auth';

import config from '../config/environments';

localStorage.removeItem('errors');

const headers = {
	'Content-Type': 'application/json',
};

if (Cookies.get('CockpitLogged')) {
	headers.CockpitLogged = Cookies.get('CockpitLogged');
}

if (Cookies.get('Token')) {
	delete headers.CockpitLogged;
	headers.Authorization = `Bearer ${Cookies.get('Token')}`;
}

export const users = axios.create({
	baseURL: `${config.APIUrl}/users`,
	withCredentials: true,
	headers,
});

const api = axios.create({
	baseURL: config.APIUrl,
	withCredentials: true,
    headers,
});

api.interceptors.response.use(
	response => response,
	(error) => {
		const forbiddenCodes = [401, 403];
		if (forbiddenCodes.includes(error.response.status)) {
			auth.logoutUser();
		}

		if (process.env.REACT_APP_ENV !== 'production') {
			localStorage.setItem('errors', error.toString());
		}

		if (process.env.NODE_ENV === 'production') {
			Sentry.captureException(error);
		}
	},
);

export const reports = (preSaleId, type) => api.get(`api/v2/reports/last?pre_sale_id=${preSaleId}&type=${type}`);
export const reportsList = {
    recurrent: () => api.get('/api/v2/reports'),
    pontual: () => api.get('/api/v2/reports'),
};

export default api;
